import { Button } from "ui-v2/components/Button";
import Modal from "ui-v2/components/Modal";
import { Typography } from "ui-v2/components/Typography";
import { ErrorPopupProps, ErrorUiTypeEnum } from "ui-v2/types/Error";
import s from "./ErrorPopup.module.scss";
import Icon from "../../Icon/Icon";
import React from "react";

export const ErrorPopup: React.FunctionComponent<ErrorPopupProps> = ({
  show,
  onClose,
  errObj,
  cta = [],
}) => {
  const getIconColor = () => {
    switch (errObj?.ui_type) {
      case ErrorUiTypeEnum.dialog_err:
        return "negative";
      case ErrorUiTypeEnum.dialog_warn:
        return "alert_dark";
      default:
        return "alert_dark";
    }
  };

  return (
    <Modal
      show={show}
      head={{ show: true, onClose: onClose }}
      rootStyle={{ zIndex: 5 }}
      variant="popup"
      animation={{ timeout: "m", type: "popup" }}
    >
      <div className={s.root}>
        <div className={s.content}>
          <div className={s.icon}>
            <Icon
              name="InfoCircleBold"
              height={48}
              width={48}
              color={getIconColor()}
            />
          </div>
          <div className={s.text}>
            <Typography label={errObj?.title} variant="h_2_bold" as="h1" />
            {errObj?.description && (
              <Typography
                label={errObj?.description}
                variant="body_3_regular"
                color="secondary"
              />
            )}
          </div>

          <div className={s.btn}>
            {cta?.length > 0 ? (
              cta.map((item, idx) => (
                <Button
                  key={`${idx}^^@`}
                  label={item?.label}
                  onClick={item?.onClick}
                  variant="primary"
                />
              ))
            ) : (
              <Button label="Close" onClick={onClose} />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
